<div class="third-party" [ngClass]="{ 'has-app-banner': showAppBanner }">
  <i class="btn-close icon-edponline-Bop-071" *ngIf="data.showClose" data-modal="dismiss()"
    (click)="closeModal(false)"  aria-hidden="true"></i>
  <div class="d-flex flex-column align-items-center px-4 pt-5">
    <div class="mt-4 text-center">
      <h3>{{ 'pt.edp.edponline.readings.add' | translate }}</h3>
      <p *ngIf="!onSuccess && !loading">{{ 'pt.edp.edponline.contract.3thparty.where_is_cpe' | translate }}</p>
    </div>
    <edp-loader *ngIf="loading" [size]="'md'" [position]="'center'" ></edp-loader>

    <div class="mt-4 text-center" *ngIf="onSuccess && !loading">
      <p>{{ 'pt.edp.edponline.contract.3thparty.we_have_registered' | translate }}
        <span class="font-weight-bold">{{holderName}}</span>
        {{ 'AddContract.ContratoAtualizado1' | translate }}
        <span class="font-weight-bold">{{holderNif}}</span>.</p>
      <p>{{ 'pt.edp.edponline.contract.3thparty.lets_concluded' | translate }}</p>
      <p>{{ 'pt.edp.edponline.contract.3thparty.go_ahead' | translate }}</p>
    </div>

    <div *ngIf="!onSuccess && !loading">
      <form [formGroup]="form" (ngSubmit)="submit()">

        <div class="input-container fluid">

          <div>
            <label class="text-label">{{ "AddContractFeature.CPECUI" | translate }}</label>
            <input type="text" placeholder="PTXXXXXXXXXXXXXXXXX" formControlName="cpecui"
              [ngClass]="{ 'error': showCpecuiError }" required />
            <span class="error input-error" [ngClass]="{ 'show': showCpecuiError}">
              {{ "AddContractFeature.CPECUIInvalido" | translate }}
            </span>
          </div>

          <div>
            <label class="text-label">{{ "AddContract.NIF" | translate }}</label>
            <input type="text" placeholder="{{ 'AddContract.9Digitos' | translate }}" formControlName="nif"
              [ngClass]="{ 'error': showNifError }" required />
            <span class="error input-error" [ngClass]="{ 'show': showNifError}">
              {{ "AddContract.NifInvalido" | translate }}
            </span>
            <span class="error" *ngIf="isAlreadyManaged">
              {{ "AddContractFeature.Geridos" | translate }}
            </span>
          </div>

          <div class="text-center mb-3">
              <button type="submit" class="btn btn-primary mt-3 px-5" [disabled]="isSubmitted || form.controls.nif.pristine || form.controls.cpecui.pristine">
                {{ "pt.edp.edponline.common.confirm" | translate }}
              </button>
          </div>


        </div>

      </form>
    </div>

    <div *ngIf="onSuccess && !loading" class="d-flex w-100 px-md-5 my-5 justify-content-between">
          <button class="btn edp-btn-secondary flex-fill mr-2" (click)="closeModal(false)">
            {{ "edpmodal.no" | translate }}
          </button>
          <button class="btn edp-btn-primary flex-fill ml-2" (click)="closeModal(true)">
            {{ "edpmodal.yes" | translate  }}
          </button>
    </div>
  </div>
</div>